<template>
    <div class="of-content4-item" @click="pageRedirect(training.link)" :data-ba-i="training.baIntelligenceTag" >
        <div :class="['tool__in', userTest? training.borderClassV5 : training.borderClass]">
            <img class="new_icon" v-if="userTest" :src="training.path_new" alt="" srcset="">
            <img class="old_icon" v-else-if="!userTest" :src="training.path" alt="" srcset="">
        </div>
        <h3 v-html="training.title"></h3>
    </div>
</template>

<script>
    export default {
        name: 'item',
        props: {
            view: {
                type: Object,
            },
            userTest: {
                type: Boolean,
            }
        },
        data() {
            return { /* default */
                path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-cheetah-website-builder.svg',
                link: '#',
                borderClass: 'border1',
                borderClassV5: 'border5',
                title: 'Cheetah Drag & Drop Website Builder',
                baIntelligenceTag: 'fc-c4-cheetah-website-builder'
            }
        },
        computed: {
            training: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.$data
            }
        },
        methods: {
            pageRedirect: function (link){
                window.open(link, "_blank")
            }
        },
        created(){

        },
        mounted(){

        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/office";

    .of-content4-item {
        font: inherit;

        box-sizing: border-box;
        background-color: $of-color3;

        box-shadow: 0 0 0.4em rgba($of-color12, 0.1); /* 4px */
        border-radius: 1.7em; /* 17px */
        padding: 1.4em 1.95em 0.2em 1.95em;/* 14px 19.5px 2px 19.5px */

        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: space-evenly;

        min-height: 24em; /* 240px */

        &:hover{
            cursor: pointer;
            border: 1px rgba($of-color1, 0.2) solid;
        }

        .tool__in {
            font: inherit;
            box-sizing: border-box;

            background-color: $of-color14;
            border-radius: 1.7em; /* 17px */

            display: flex;
            align-items: center;
            justify-content: center;

            padding: 3.95em 4.25em; /* 39.5px 42.5px */

            img {
                font: inherit;

                .new_icon{
                    width: 17em;
                    height: 17em;
                }
                .old_icon{
                    width: 10em;
                    height: 10em;
                }
            }
        }
        h3 {
            font: inherit;

            font-size: 1.2em; /* 12px */
            text-align: center;
            color: #707070;
            text-transform: uppercase;
            font-weight: 700;
            line-height: 1.5;

            margin: 0;
        }

        /* cor de borda personalizada */
        .border1{
            border: 1px $of-color15 solid;
        }

        .border2{
            border: 1px $of-color16 solid;
        }

        .border3{
            border: 1px $of-color17 solid;
        }

        .border4{
            border: 1px $of-color18 solid;
        }
        .border5{
            //border: 1px $of-color26 solid;
            padding: 0 !important;
        }
    }

    @media (max-width: 768px) { /* smartphones e tablets */
        .of-content4-item {
            h3 {
                font-size: 1.44em; /* 14.4px */
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-4/item.vue